import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import { LocationInfo } from '../common/googlemap.service';
import { AppConstants, SERVER, LOGON_INFO, CARGO_STATUS, COMP_TYPE, SHARE_FLAG } from "../app.constants";
import { Car } from "../member-kanri/car.service";
import { CommonService } from "../app.service";


@Injectable()
export class CargoService {

    logon_user_id: string;
    logon_comp_id: string;
    logon_comp_type: string;
    logon_parent_comp_id: string;
    logon_car_id: number;

    constructor(
        private _htc: HttpClient,
        private commonService: CommonService
    ) {
        this.logon_user_id = LOGON_INFO.USER_ID;
        this.logon_comp_id = LOGON_INFO.COMP_ID;
        this.logon_comp_type = LOGON_INFO.COMP_TYPE;
        this.logon_parent_comp_id = LOGON_INFO.PARENT_COMP_ID;
        this.logon_car_id = LOGON_INFO.CAR_ID;
    }

    //貨物リストを取得
    getCargoList(div: string, page: number, search_status: string, search_todohuken: string, search_date_start: any, search_date_end: any): Observable<Cargo[]> {
        let params = new HttpParams().set('page', page.toString())
                                    .append('user_id', this.logon_user_id)
                                    .append('search_status', search_status)
                                    .append('search_todohuken', search_todohuken)
                                    .append('search_date_start', search_date_start ? search_date_start.formatted : "")
                                    .append('search_date_end', search_date_end ? search_date_end.formatted : "");
        return this._htc.get<Cargo[]>(SERVER.baseURL+'/cargo-list/'+div+'/'+this.logon_comp_id+'/', {params: params});
    }

    searchCargoForMobile(search_todohuken: string, search_day_add: number, search_weight: number, search_radius: number, deviceLat: number, deviceLng: number): Observable<Cargo[]> {
        let params = new HttpParams().set('search_todohuken', search_todohuken)
                    .append('search_day_add', this.commonService.numToStr(search_day_add))
                    .append('search_weight', this.commonService.numToStr(search_weight))
                    .append('search_radius', this.commonService.numToStr(search_radius))
                    .append('carLat', this.commonService.numToStr(deviceLat))
                    .append('carLng', this.commonService.numToStr(deviceLng))
                    .append('search_date_start', (new Date()).toLocaleDateString());
        return this._htc.get<Cargo[]>(SERVER.baseURL+'/cargo-list/search/'+this.logon_comp_id+'/', {params: params});
    }

    //積み・卸し地の履歴リスト取得
    getAddressHistoryList(div: string): Observable<LocationInfo[]> {
        let params = new HttpParams().set('user_id', this.logon_user_id);
        let id = this.logon_comp_id == "C00000" ? this.logon_user_id : this.logon_comp_id;
        return this._htc.get<LocationInfo[]>(SERVER.baseURL+'/cargo-addr-history/'+this.logon_comp_id+'/'+div+'/', {params: params});
    }

    //貨物登録
    registCargo(cargo: Cargo) {
        this.setParam(cargo);
        
        //複写で新規登録時にundefinedを設定しパラメータとして渡されないようにする
        cargo.id = undefined;
        cargo.status = undefined;
        cargo.trans_comp_id = undefined;
        cargo.trans_car_id = undefined;
        cargo.trans_driver_id_1 = undefined;
        cargo.trans_driver_id_2 = undefined;
        cargo.trans_driver_id_3 = undefined;
        cargo.cargo_width = 0;
        cargo.cargo_height = 0;
        cargo.cargo_depth = 0;

        //貨物登録者が荷主　かつ　グループ関係がある(親会社がある)場合
        if (this.logon_comp_type == COMP_TYPE.CLIENT && this.logon_comp_id != this.logon_parent_comp_id) {
            cargo.share_comp_id = this.logon_parent_comp_id;
        }
        //貨物登録者が運送会社の場合
        else if (this.logon_comp_type != COMP_TYPE.CLIENT) {
            cargo.share_comp_id = this.logon_comp_id;
        }

        /*
        var cargoList = [];
        for (var i=0; i<cargo.require_car_amount; i++) {
            cargoList[i] = cargo;
        }*/
        
        return this._htc.post<Cargo>(SERVER.baseURL+'/cargo-regist/', JSON.stringify(cargo));
    }

    //貨物情報更新
    updateCargo(cargo: Cargo) {
        this.setParam(cargo);
        cargo.client_comp_id = undefined;
        cargo.create_id = undefined;
        return this._htc.put<Cargo>(SERVER.baseURL+'/cargo-update/'+cargo.id+'/', JSON.stringify(cargo));
    }

    //貨物重要度変更
    updateCargoImportance(id: number, importance: string) {
        return this._htc.put<Cargo>(SERVER.baseURL+'/cargo-importance-update/'+id+'/', JSON.stringify({importance:importance}));
    }

    //貨物キャンセル
    cancelCargo(id: number) {
        return this._htc.put<Cargo>(SERVER.baseURL+'/cargo-cancel/'+id+'/', JSON.stringify({status:CARGO_STATUS.CANCEL, update_id:this.logon_user_id}));
    }

    //貨物削除（論理削除）
    deleteCargo(id: number) {
        return this._htc.put<Cargo>(SERVER.baseURL+'/cargo-delete/'+id+'/', JSON.stringify({update_id:this.logon_user_id}));
    }

    //貨物運送依頼の受付
    acceptCargo(id: number) {
        return this._htc.put<Cargo>(SERVER.baseURL+'/cargo-accept/'+id+'/', JSON.stringify({trans_comp_id:this.logon_comp_id, update_id:this.logon_user_id}));
    }

    //貨物運送依頼の受付 (ドライバーから)
    acceptCargoFromDriver(id: number) {
        return this._htc.put<Cargo>(SERVER.baseURL+'/cargo-accept-from-driver/'+id+'/', JSON.stringify({trans_comp_id:this.logon_comp_id, trans_car_id:this.logon_car_id, update_id:this.logon_user_id}));
    }

    //貨物運送依頼の受付の取消
    acceptCancelCargo(id: number) {
        return this._htc.put<Cargo>(SERVER.baseURL+'/cargo-accept-cancel/'+id+'/', JSON.stringify({update_id:this.logon_user_id}));
    }

    //車両配車
    matchCar(id: number, car: Car) {
        let param = {
            trans_comp_id: this.logon_comp_id,
            trans_car_id: car.id,
            update_id: this.logon_user_id
        };
        return this._htc.put<Cargo>(SERVER.baseURL+'/cargo-match-car/'+id+'/', JSON.stringify(param));
    }

    //車両配車取消
    matchCarCancel(id: number, match_car_id: number) {
        return this._htc.put<Cargo>(SERVER.baseURL+'/cargo-match-car-cancel/'+id+'/', JSON.stringify({trans_car_id:match_car_id, update_id:this.logon_user_id}));
    }

    //運送状況報告
    reportTransStatus(id: number, status: string) {
        return this._htc.put<Cargo>(SERVER.baseURL+'/cargo-report/'+id+'/', JSON.stringify({status:status, update_id:this.logon_user_id}));
    }


    private setParam(cargo: Cargo) {
        cargo.create_id = this.logon_user_id;
        cargo.update_id = this.logon_user_id;
        cargo.load_date = cargo.load_date.formatted.split('/').join('-');
        cargo.load_date_end = cargo.load_date_end.formatted.split('/').join('-');
        cargo.drop_date = cargo.drop_date.formatted.split('/').join('-');
        cargo.drop_date_end = cargo.drop_date_end.formatted.split('/').join('-');
        cargo.load_latitude  = this.commonService.decimalRound(cargo.load_latitude, 6);
        cargo.load_longitude = this.commonService.decimalRound(cargo.load_longitude, 6);
        cargo.drop_latitude  = this.commonService.decimalRound(cargo.drop_latitude, 6);
        cargo.drop_longitude = this.commonService.decimalRound(cargo.drop_longitude, 6);
        cargo.client_comp_id = this.logon_comp_id;

        cargo.importance = undefined;
        cargo.new_flag = undefined;
        cargo.trans_car_no = undefined;
        cargo.status_name = undefined;
        cargo.importance_name = undefined;
        cargo.client_comp_name = undefined;
        cargo.load_lat = undefined;
        cargo.load_lng = undefined;
        cargo.load_time_name = undefined;
        cargo.drop_time_name = undefined;
        cargo.load_method_name = undefined;
        cargo.trans_comp_name = undefined;
        cargo.trans_driver_name = undefined;
        cargo.share_flag = undefined;
        cargo.share_comp_id = undefined;
        cargo.share_flag_2 = undefined;
        cargo.share_comp_id_2 = undefined;
        cargo.share_comp_name = undefined;
        cargo.is_active = undefined;
        cargo.create_date = undefined;
        cargo.update_date = undefined;
    }



    updateShareInfo(cargo: Cargo): Observable<Cargo> {
        let param = {
            share_flag: cargo.share_flag,
            share_comp_id: cargo.share_comp_id,
            share_flag_2: cargo.share_flag_2,
            share_comp_id_2: cargo.share_comp_id_2,
            update_id: this.logon_user_id
        };
        return this._htc.put<Cargo>(SERVER.baseURL+'/cargo-share-update/'+cargo.id+'/', JSON.stringify(param));
    }


    ////////// autoRefresh用　START ///////////////////////////////////////////////////
    isAccessibleCargo(cargo: Cargo): boolean {
        if (cargo.share_flag == SHARE_FLAG.ALL
            || (cargo.share_flag == SHARE_FLAG.COMPANY && cargo.share_comp_id == LOGON_INFO.COMP_ID)
            || cargo.share_flag_2 == SHARE_FLAG.ALL
            || (cargo.share_flag_2 == SHARE_FLAG.COMPANY && cargo.share_comp_id_2 == LOGON_INFO.COMP_ID)
            || (cargo.share_flag_2 == SHARE_FLAG.BRANCH && LOGON_INFO.COMP_TYPE == COMP_TYPE.BRANCH && cargo.share_comp_id_2 == LOGON_INFO.PARENT_COMP_ID)
            || (cargo.share_flag_2 == SHARE_FLAG.PARTNER && LOGON_INFO.COMP_TYPE == COMP_TYPE.PARTNER && cargo.share_comp_id_2 == LOGON_INFO.PARENT_COMP_ID)) {
                return true;
        }
        return false;
    }

    addCargoToList(cargoList: Cargo[], cargo: Cargo, searchLoadTodohuken: string): boolean {
        if (searchLoadTodohuken && cargo.load_todohuken != searchLoadTodohuken) {
            return false;
        }
        if (!cargoList || !cargoList.length) {
            cargoList.push(cargo);
        } else {
            cargoList.unshift(cargo);
            cargoList.sort(function(a,b) {
                return b.id - a.id;
            });
            if (cargoList.length > AppConstants.PAGE_SIZE_LARGE) {
                cargoList.pop();
            }
        }
        
        return true;
    }

    deleteCargoFromList(cargoList: Cargo[], cargo: Cargo): boolean {
        let idx = cargoList.findIndex(({id}) => id === cargo.id);
        if (idx > -1) {
            cargoList.splice(idx, 1);
            return true;
        }
        return false;
    }

    replaceCargoFromList(cargoList: Cargo[], cargo: Cargo): boolean {
        let idx = cargoList.findIndex(({id}) => id === cargo.id);
        if (idx > -1) {
            cargoList.splice(idx, 1, cargo);
            return true;
        }
        return false;
    }
    ////////// autoRefresh用　END ///////////////////////////////////////////////////

}




export class Cargo {
    id: number;
    status: string;
    status_name: string;
    new_flag: string;
    importance: string;
    importance_name: string;
    client_comp_id: string;
    client_comp_name: string;
    cargo_item: string;
    load_todohuken: string;
    load_address: string;
    load_longitude: number;
    load_latitude: number;
    load_lat: number;
    load_lng: number;
    load_date: any;
    load_date_end: any;
    load_time: string;
    load_time_name: string;
    load_time_end: string;
    drop_todohuken: string;
    drop_address: string;
    drop_longitude: number;
    drop_latitude: number;
    drop_date: any;
    drop_date_end: any;
    drop_time: string;
    drop_time_name: string;
    drop_time_end: string;
    load_drop_date: string;
    car_ability: string;
    car_ability_name: string;
    load_method: string;
    load_method_name: string;
    require_equipment: string;
    require_car_type: string;
    cargo_height: number;
    cargo_width: number;
    cargo_depth: number;
    cargo_num: number;
    cargo_size: string;
    load_weight: number;
    charge: number;
    charge_unit: string;
    commission: number;
    charter_flag: boolean;
    cool_flag: boolean;
    etc: string;
    trans_comp_id: string;
    trans_comp_name: string;
    trans_car_id: number;
    trans_car_no: string;
    trans_driver_id_1: string;
    trans_driver_id_2: string;
    trans_driver_id_3: string;
    trans_driver_name: string;
    share_flag: string;
    share_comp_id: string;
    share_flag_2: string;
    share_comp_id_2: string;
    share_comp_name: string;
    is_active: string;
    create_id: string;
    create_date: Date;
    update_id: string;
    update_date: Date;
}




// WEBPACK FOOTER //
// ./src/app/cargo/cargo.service.ts